import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Config đọc từ biến môi trường (.env) — xem .env.example.
// Các giá trị này vẫn nằm trong bundle phía client theo đúng thiết kế của
// Firebase web SDK; phần bảo vệ dữ liệu nằm ở Realtime Database Rules.
const requireEnv = (key: keyof ImportMetaEnv): string => {
    const value = import.meta.env[key];
    if (!value) {
        throw new Error(
            `Thiếu biến môi trường ${key}. Copy .env.example thành .env và điền config Firebase của bạn.`
        );
    }
    return value;
};

const firebaseConfig = {
    apiKey: requireEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    databaseURL: requireEnv('VITE_FIREBASE_DATABASE_URL'),
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: requireEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: requireEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: requireEnv('VITE_FIREBASE_APP_ID')
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
